<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4>
        <v-card :loading="loading" tile>
          <v-form v-model="formValid" @submit.prevent="signIn(confirmedEmail)">
            <v-card-title><h2>Email Link Authentication</h2></v-card-title>
            <v-card-text>
              <p>
                {{
                  askForEmail
                    ? 'Please confirm your email address'
                    : 'Please wait...'
                }}
              </p>
              <v-text-field
                v-if="askForEmail"
                filled
                type="email"
                label="Email address"
                v-model="confirmedEmail"
                required
                :rules="[rules.required, rules.email]"
              ></v-text-field>
            </v-card-text>
            <v-card-actions v-if="askForEmail">
              <v-spacer></v-spacer>
              <v-btn
                class="button"
                color="primary"
                :loading="loading"
                :disabled="!formValid"
                @click.prevent="signIn(confirmedEmail)"
                >Confirm</v-btn
              >
            </v-card-actions>
          </v-form>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { auth } from '@/firebaseConfig'
import { mapActions, mapGetters } from 'vuex'
import { textFieldRules } from '@/common'

export default {
  name: 'LoginEmail',
  data() {
    return {
      formValid: false,
      loading: false,
      askForEmail: false,
      confirmedEmail: '',
      rules: textFieldRules,
    }
  },
  async created() {
    if (!this.emailForSignIn) {
      this.askForEmail = true
      this.loading = false
    } else {
      this.signIn(this.emailForSignIn)
    }
  },
  computed: {
    ...mapGetters(['emailForSignIn']),
  },
  methods: {
    ...mapActions(['setCompanyId', 'showError', 'currentCompany']),
    async signIn(email) {
      if (!email) {
        this.showError('Please confirm your email address')
        return
      }

      this.loading = true
      const company_id = this.$route.query.company_id

      const url = location.href
      if (auth.isSignInWithEmailLink(url)) {
        try {
          const result = await auth.signInWithEmailLink(email, url)

          const user = (({ uid, email, displayName }) => ({
            uid,
            email,
            displayName,
          }))(result.user)
          this.$store.commit('setCurrentUser', user)
          this.$store.dispatch('getCurrentUserScopes')

          this.$store.dispatch('emailForSignIn', null)
          if (company_id) {
            // set company
            this.setCompanyId(company_id)
            this.$router.push({ name: 'jobs' })
          } else {
            this.$router.push({ name: 'launchpad' })
          }
        } catch (error) {
          console.error(error)
          this.showError('Failed. ' + error.message)
        } finally {
          this.loading = false
        }
      } else {
        console.error('Invalid link')
        this.showError('Invalid link')
      }

      this.loading = false
    },
  },
  watch: {
    currentCompany(newValue) {
      if (newValue != null) {
        this.$router.push('/')
      }
    },
  },
}
</script>
